import React from 'react'
import { Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'

export const Root = styled(ContainerBase)`
  &.MuiContainer-root {
    width: 100%;
  }
`

export const GridContainer = styled(({ height, margin, maxWidth, padding, ...props }) => (
  <GridBase container {...props} />
))`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(({ height, margin, padding, textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 27px;
  font-weight: bold;
  line-height: 32px;
  margin: 0;
  padding: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
  padding: 0;
`

export const Info = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: right;
`

export const Total = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  margin: 0;
`

export const Strong = styled('strong')``
